<template>
  <div class="profilestrategy-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('profilestrategy_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-strategy</v-icon>{{$t('profile.strategy.strategies')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ProfileStrategyFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.profileStrategyQualities" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['profileStrategyQualities']" :key="_item.id">
                      {{ _item.id }}
                    </li>
                  </ul>
                </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProfileStrategyFilterForm from '../../components/profilestrategy/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProfileStrategyList',
  servicePrefix: 'ProfileStrategy',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ProfileStrategyFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.strategy.uuid'), value: 'uuid' },
        { text: this.$t('profile.strategy.software'), value: 'software.name' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('profilestrategy', {
      items: 'list'
    }),
    ...mapFields('profilestrategy', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('profilestrategy', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
